import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Text, Heading } from '../components/ui'
import { BRAND_COLOR } from '../constants'

const TestReset: React.FC = () => {
  const baseUrl = 'http://localhost:3000/reset-password'
  
  const testUrls = [
    {
      name: 'Formato 1: access_token e refresh_token',
      url: `${baseUrl}?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.test&refresh_token=test-refresh`
    },
    {
      name: 'Formato 2: apenas token',
      url: `${baseUrl}?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.test`
    },
    {
      name: 'Formato 3: type=recovery com refresh_token',
      url: `${baseUrl}?type=recovery&refresh_token=test-refresh`
    },
    {
      name: 'Formato 4: apenas type=recovery',
      url: `${baseUrl}?type=recovery`
    },
    {
      name: 'Formato 5: sem parâmetros',
      url: baseUrl
    }
  ]

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
        <div className="flex justify-center">
          <div 
            className="w-12 h-12 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: BRAND_COLOR }}
          >
            <span className="text-white text-xl font-bold">P</span>
          </div>
        </div>
        <Heading as="h2" size="2xl" className="mt-6 text-center">
          Teste de Reset de Senha
        </Heading>
        <Text size="sm" color="muted" className="mt-2 text-center">
          Clique nos links abaixo para testar diferentes formatos de URL
        </Text>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-2xl">
        <div className="bg-white dark:bg-gray-800 py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="space-y-4">
            {testUrls.map((test, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <Text size="sm" className="font-medium mb-2">
                  {test.name}
                </Text>
                <Text size="xs" color="muted" className="mb-3 break-all">
                  {test.url}
                </Text>
                <Link to={test.url}>
                  <Button
                    size="sm"
                    style={{ backgroundColor: BRAND_COLOR }}
                    className="text-white"
                  >
                    Testar este formato
                  </Button>
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <Link to="/login">
              <Button
                className="w-full text-white"
                style={{ backgroundColor: BRAND_COLOR }}
              >
                Voltar para o login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestReset
